import {ETFHolding} from "@/integrations/supabase/etf.models.ts";

const FREQUENCY_MULTIPLIER: Record<ETFDividendFrequency, number> = {
    monthly: 12,
    quarterly: 4,
    semi_annual: 2,
    annual: 1,
};

/** Computed metrics derived from an ETF holding and its current market price. */
export function computeETFMetrics(holding: ETFHolding, currentPrice: number) {
    const marketValue = holding.units_held * currentPrice;
    const costBasis = holding.units_held * holding.average_cost_per_unit;
    const totalReturn = marketValue - costBasis;
    const totalReturnPct = costBasis > 0 ? (totalReturn / costBasis) * 100 : 0;
    const multiplier = FREQUENCY_MULTIPLIER[holding.dividend_frequency] ?? 4;
    const annualYield = holding.units_held * holding.dividend_per_unit * multiplier;
    return { marketValue, costBasis, totalReturn, totalReturnPct, annualYield };
}